import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Wallet } from 'lucide-react';

export default function AuthCallback() {
  const { loginWithSessionId } = useAuth();
  const location = useLocation();
  const nav = useNavigate();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) { nav('/login', { replace: true }); return; }
    (async () => {
      try {
        await loginWithSessionId(sessionId);
        window.history.replaceState(null, '', '/dashboard');
        nav('/dashboard', { replace: true });
      } catch (e) {
        nav('/login', { replace: true });
      }
    })();
  }, [location.hash, loginWithSessionId, nav]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 rounded-xl bg-emerald-500 grid place-items-center animate-pulse"><Wallet className="h-6 w-6 text-white" /></div>
        <p className="text-muted-foreground font-mono text-sm">Autenticando…</p>
      </div>
    </div>
  );
}
